/** Canonical `definition_size_category` facet values (UI sort order and URL allowlist). */
export const DEFINITION_SIZE_CATEGORY_VALUES = ["minimal", "low", "mid", "high", "very"] as const;

export type DefinitionSizeCategoryValue = (typeof DEFINITION_SIZE_CATEGORY_VALUES)[number];

export const DEFINITION_SIZE_CATEGORY_VALUE_SET: ReadonlySet<string> = new Set(DEFINITION_SIZE_CATEGORY_VALUES);
